import { useEffect, useState } from "react";

import FormBuilderDeletePopup from "../../../../Layouts/Modal/FormBuilderDeletePopup";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";

import "./ActivityFlow.css";

const EdgeEditSidebar = ({ edge, onSave, onDelete, onClose }) => {
  const [label, setLabel] = useState(edge.label || "");
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  useEffect(() => {
    setLabel(edge.label || "");
  }, [edge.id, edge.label]);

  // Listen for delete confirmation response
  useEffect(() => {
    const handleDeleteResponse = (event) => {
      const response = event.detail;

      if (response === "delete") {
        onDelete();
      }

      setShowDeletePopup(false);
    };

    document.addEventListener("userDeleteResponse", handleDeleteResponse);

    return () => {
      document.removeEventListener("userDeleteResponse", handleDeleteResponse);
    };
  }, [onDelete]);

  const handleSave = () => {
    onSave({ label });
  };

  const handleDeleteClick = () => {
    setShowDeletePopup(true);
  };

  return (
    <>
      <div className="edit_sidebar">
        <div className="edit_sidebar_header">
          <h3>Edit Connection</h3>
          <button onClick={onClose} className="close_btn">
            <MaterialIcon name="close" />
          </button>
        </div>

        <div className="edit_sidebar_content">
          <div className="form_group">
            <label>Connection Label</label>
            <input
              type="text"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              placeholder="Add a label"
              className="form_input"
            />
          </div>
        </div>

        <div className="edit_sidebar_footer">
          <button onClick={handleDeleteClick} className="btn_delete">
            Delete
          </button>
          <button onClick={handleSave} className="btn_save">
            Save
          </button>
        </div>
      </div>

      {showDeletePopup && <FormBuilderDeletePopup action="delete" message="this connection" info="confirmation" />}
    </>
  );
};

export default EdgeEditSidebar;
